import { DEFAULT_FOOTER_LINKS, DEFAULT_FOOTER_LINKS_NO_CAR, DEFAULT_HEADER_LINKS, DEFAULT_HEADER_LINKS_NO_CAR } from '../config/links.esm.js';

var isExternalHeaderLink = function(item) {
    return typeof item !== "string";
};
function getFooterLinksByCountryAndRegion(countryRegion) {
    switch(countryRegion){
        case "US-CA":
            return DEFAULT_FOOTER_LINKS_NO_CAR;
        default:
            return DEFAULT_FOOTER_LINKS;
    }
}
function getHeaderLinksByCountryAndRegion(countryRegion) {
    switch(countryRegion){
        case "US-CA":
            return DEFAULT_HEADER_LINKS_NO_CAR;
        default:
            return DEFAULT_HEADER_LINKS;
    }
}

export { getFooterLinksByCountryAndRegion, getHeaderLinksByCountryAndRegion, isExternalHeaderLink };
